/* WCAG 2.2 AA — runtime repair for DOM we cannot fix in Liquid.
   Theme-code fixes live in nc-a11y.css and in the sections/snippets themselves;
   this file is strictly for markup produced by third-party components at runtime.
   See docs/a11y/. Safe to run repeatedly (idempotent + guarded). */
(function () {
  'use strict';

  /* 4.1.2 aria-valid-attr-value — 12 instances, every page on the site.
     <swiper-container> renders .swiper-wrapper INSIDE its shadow root, but the
     navigation buttons live in the light DOM (they are passed in via
     navigation-next-el / navigation-prev-el). Swiper's a11y module still points
     their aria-controls at the wrapper's id, which no light-DOM lookup can ever
     resolve — so it is an invalid reference that tells assistive tech nothing.

     Swiper already gives these buttons a real aria-label ("Next slide" /
     "Previous slide"), so dropping the dangling attribute loses nothing and
     removes the violation. We only touch buttons whose target genuinely is not
     in the document, so a valid aria-controls elsewhere is never disturbed. */
  function stripDanglingAriaControls(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll(
      '[id^="swiper-custom-button-"][aria-controls], .swiper-button-next[aria-controls], .swiper-button-prev[aria-controls]'
    );
    Array.prototype.forEach.call(buttons, function (btn) {
      var id = btn.getAttribute('aria-controls');
      if (!id || document.getElementById(id)) return; // valid reference — leave alone
      btn.removeAttribute('aria-controls');
      if (!btn.dataset.ncA11yGuard) {
        // Swiper re-applies the attribute on re-init (breakpoint changes,
        // section re-render in the theme editor). Watch this button and strip
        // it again whenever that happens.
        btn.dataset.ncA11yGuard = '1';
        new MutationObserver(function () {
          var v = btn.getAttribute('aria-controls');
          if (v && !document.getElementById(v)) btn.removeAttribute('aria-controls');
        }).observe(btn, { attributes: true, attributeFilter: ['aria-controls'] });
      }
    });
  }

  function run() {
    stripDanglingAriaControls(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Swiper initialises asynchronously; catch the buttons once it has.
  window.addEventListener('load', run);
  setTimeout(run, 1200);

  // Sections re-render in the theme editor and sliders can mount late.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].addedNodes && records[i].addedNodes.length) { run(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
